const AssetsPack = {
  icons: {
    ICON_TICK: await import("../assets/tickIcon.svg"),
    ICON_CLOSE: await import("../assets/closeIcon.svg"),
    ICON_BRAIN: await import("../assets/brainIcon.svg"),
    ICON_CREATE_NEW: await import("../assets/createNewIcon.svg"),
    ICON_EDIT: await import("../assets/editIcon.svg"),
    ICON_FAILED: await import("../assets/failedIcon.svg"),
    ICON_NEED_APPROVAL: await import("../assets/needApprovalIcon.svg"),
    ICON_PRE_APPROVED: await import("../assets/preApprovedIcon.svg"),
    ICON_REJECT: await import("../assets/rejectIcon.svg"),
    ICON_PLUS: await import("../assets/plus.svg"),
    ICON_CLOSE_GRAY: await import("../assets/close.svg"),
    ICON_RETURN: await import("../assets/returnIcon.svg"),
    ICON_CANCEL: await import("../assets/cancelEditIcon.svg"),
    ICON_SAVE: await import("../assets/savePreapproveIcon.svg"),
    ICON_DROPDOWN: await import("../assets/dropdown.svg"),
    ICON_CONVERSATION: await import("../assets/conversationIcon.svg"),
    ICON_CUSTOMER: await import("../assets/person.png"),
    ICON_CUSTOMER_SUPPORT: await import("../assets/icon-customer-service.png"),
    ICON_ROBOT: await import("../assets/icon-robot.png"),
    ICON_END_CONVERSATION: await import("../assets/endConversationIcon.svg"),
    ICON_REGENERATE: await import("../assets/regenerate.svg"),
    ICON_CORE: await import("../assets/coreIcon.svg"),
    ICON_GALLERY: await import("../assets/icons/images-svgrepo-com.svg"),
    ICON_MAX: await import("../assets/maxIcon.svg"),
    ICON_DELETE: await import("../assets/delete.svg"),
    ICON_BACK: await import("../assets/back_arrow.svg"),
    ICON_JOKER_AI: await import("../assets/icons/iconJokerAi.svg"),
    ICON_ARROW_RIGHT: await import("../assets/icons/japIconSendChev.svg"),
  },
  logos: {
    LOGIN_PAGE_LOGO: await import("../assets/ai_brain.svg"),
  },
  backgrounds: {},
  videos: {},
  images: {
    JAP_INTRO_CARD_01: {
      main: await import("../assets/img/imgIntroCard01.png"),
      srcSet: {
        "1x": await import("../assets/img/imgIntroCard01.png"),
        "2x": await import("../assets/img/imgIntroCard01@2x.png")
      }
    },
    JAP_INTRO_CARD_02: {
      main: await import("../assets/img/imgIntroCard02.png"),
      srcSet: {
        "1x": await import("../assets/img/imgIntroCard02.png"),
        "2x": await import("../assets/img/imgIntroCard02@2x.png")
      }
    },
  },
};

export default AssetsPack;
